import { Component, ChangeDetectionStrategy } from "@angular/core";
import { StorageService, UserService, StorageKeys, environment, HelperService, LanguageService } from "@mypxplat/xplat/core";
import { AppBaseComponent, AppService, AvoService, ReftagService, ScriptService } from "@mypxplat/xplat/web/core";
import { SwitchLanguageComponent } from "@mypxplat/xplat/web/features";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs";
import moment from "moment";
import { Location } from "@angular/common";

// xplat

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-root",
  templateUrl: "./app.component.html",
  standalone: false,
})
export class AppComponent extends AppBaseComponent {
  constructor(
    userService: UserService,
    public appService: AppService,
    public avoService: AvoService,
    private _storageService: StorageService,
    private _translateService: TranslateService,
    private _scriptService: ScriptService,
    public reftagService: ReftagService,
    public helperService: HelperService,
    private _location: Location,
    private _languageService: LanguageService
  ) {
    super(userService);
    this.appService.app = "admin";
    this.userService.appId = "admin";
  }

  ngOnInit() {
    // check if "zendesk" is a url parameter, and if so, add a class to the body
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("zendesk")) {
      document.body.classList.add("zendesk");
    }
    this._languageService.initializeLanguage(this.user);
    this.appService.initTheme();
    this.helperService.backPressed$.pipe(takeUntil(this.destroy$)).subscribe((result) => {
      this._location.back();
    });
  }
}
